import {HistoryStep} from "./historyStep";
import {HistoryController, IHistoryStepWithSelObs} from "./historyController";
import {EventVerteiler} from "@k/global/eventVerteiler";
import {SELOBEVENTNAMES} from "@k/global/GlobalEventnames";

import {CONSTANTS} from "../meta_data";
import {SelectableObject} from "../selectableObjects";

export class HistoryStepSelObRemoved extends HistoryStep implements IHistoryStepWithSelObs {
    private selOb;
    private readonly cloneIdsOnDelete;
    private readonly zIndexOnRemoval;

    constructor(historyController: HistoryController, parameters) {
        if (typeof (parameters.type) !== "string") {
            parameters.type = "selObRemoved";
        }
        super(historyController, parameters);

        this.selOb = parameters.selOb.clone(true);
        this.zIndexOnRemoval = this.controller.selObController.getZIndexOfSelOb(parameters.selOb.id);
        this.cloneIdsOnDelete = this.selOb.cloneIds.slice();
    }

    undo() {
        const $this = this;
        this.controller.restoreCameraAndModelSettings(this.viewDetails);
        this.busy();
        setTimeout(
            function () {
                $this.controller.selObController.insertSelObFromStorage($this.selOb.clone(true), $this.zIndexOnRemoval);
                EventVerteiler.broadcast(SELOBEVENTNAMES.SELECTION_REQUEST, $this.selOb.id);
                $this.createCloneCreationWaiter(
                    $this.selOb.id,
                    $this.cloneIdsOnDelete.length,
                    function (newCloneIds) {
                        $this.controller.replaceIds($this.cloneIdsOnDelete, newCloneIds);
                    }
                );
                $this.noLongerBusy();
            },
            CONSTANTS.UNDO_DELAY
        );

    }

    redo() {
        const $this = this;
        this.controller.restoreCameraAndModelSettings(this.viewDetails);
        this.busy();
        setTimeout(
            function () {
                $this.controller.selObController.deleteSelOb($this.selOb.id);

                $this.noLongerBusy();
            },
            CONSTANTS.UNDO_DELAY
        );
    }

    replaceId(origId, newId) {
        HistoryStep.replaceValueInArray(origId, newId, this.cloneIdsOnDelete);
        if (this.selOb.id === origId) {
            this.selOb.id = newId;
        }
    }
}